import React from 'react';

const Step4Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-4">
        Seleziona, tra quelle riportate, la tipologia di falda che più corrisponde a quella del tuo tetto.
        </div>
    );
}

export default Step4Infos;